<template>
  <div class="col order-1 order-lg-2">
    <div class="row mt-5">
      <div class="col text-center">
        <h2>{{ course.title }}</h2>
        <div v-if="course.cover_photo" class="row mt-4">
          <div class="col-12 offset-0 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
            <ImageComponent :component="{ file: course.cover_photo }"></ImageComponent>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <input v-model="query" type="text" class="form-control" :placeholder="$t('Search')" />
    </div>
    <div class="row mt-4">
      <div v-for="section in filteredSections" :key="section.id" class="col-12 col-md-6 col-lg-4">
        <div class="h4">
          {{ section.title }}
        </div>

        <ul class="list-group">
          <li class="list-group-item px-0" v-for="lecture in section.lectures" :key="lecture.id">
            <Lecture :key="lecture.id" :lecture="lecture"></Lecture>
          </li>
        </ul>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col text-center">
        <transition name="fade" mode="out-in">
          <button key="1" v-if="lastLecture" class="btn btn-primary" @click.prevent="goBackToLastLecture">
            {{ 'Continue lerning' | translate }}
          </button>
          <button key="2" v-else-if="firstLecture" class="btn btn-primary" @click.prevent="goToFirstLecture">
            {{ 'start learning' | translate }}
          </button>
          <div key="3" v-else-if="course.type === 'bundle'" class="bg-light p-5">
            <a href="/" class="btn btn-primary">{{ 'Go to your product list' | translate }}</a>
          </div>
          <div key="4" v-else-if="hasLoaded" class="bg-light p-5">
            <p class="lead">{{ 'No published lectures in this course yet' | translate }}.</p>
            <p class="lead">{{ 'Please contact me if you have any questions' | translate }}.</p>
          </div>
          <div key="5" v-else class="mt-5 text-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import ImageComponent from './../components/Image'
import Lecture from '~/player/components/Lecture.vue'
import _ from 'lodash'

export default {
  components: {
    ImageComponent,
    Lecture,
  },
  computed: {
    filteredSections() {
      return this.course.sections
        .map((section) => {
          const filteredLectures = section.lectures.filter((lecture) =>
            lecture.title.toLowerCase().includes(this.query.toLowerCase()),
          )
          return {
            ...section,
            lectures: filteredLectures,
          }
        })
        .filter((section) => section.lectures.length > 0)
    },
    hasLoaded() {
      if (_.get(this.course, 'id')) {
        return true
      }
      return false
    },
    course() {
      return this.$store.state.course
    },
    firstLecture() {
      return this.$store.getters.firstLecture
    },
  },
  data() {
    return {
      query: '',
      lastLecture: localStorage.getItem(this.$route.params.course),
    }
  },
  mounted() {
    if (_.get(this.course, 'settings.layout', 0) === 1) {
      // this.$store.commit('setSideBarLeft', null)

      return true
    } else if (this.lastLecture && this.lectureExists(this.lastLecture)) {
      this.goBackToLastLecture()
    } else if (this.firstLecture) {
      this.goToFirstLecture()
    }
    // setTimeout(, 5000)
  },
  methods: {
    lectureExists(id) {
      return _.some(
        _.flatMap(this.course.sections, (section) => section.lectures),
        { id: _.toInteger(id) },
      )
    },
    noLecturesYet() {},
    goBackToLastLecture() {
      return this.$router.replace({
        name: 'lecture',
        params: { lecture: this.lastLecture },
      })
    },
    goToFirstLecture() {
      if (this.firstLecture) {
        return this.$router.push({
          name: 'lecture',
          params: { lecture: this.firstLecture.id },
        })
      }
      return null
    },
  },
}
</script>
